import * as React from "react";
import { TBannerItem } from "../../../services/banner";
import NextImage from "../../../components/NextImage";
import {
    LinkTargetType,
    TModuleWithImgProps,
} from "../../../services/playground";
import { isNotBlankArray } from "utils/array";

import { Container, CarouselWrapper } from "./styles";
import { transformAParam } from "utils/browser";
import { getMaxHeight, webCarouselWidth } from "./utils";
import { formatBannerGridSize } from "views/utils/banner";

interface CarouselProps extends TModuleWithImgProps {
    banners: TBannerItem[];
    showArrow: boolean;
    showDots?: boolean;
    onClick?: (link: string) => void;
}
interface CarouselState {
    current: number;
    pause: boolean;
}

class WebCarousel extends React.Component<CarouselProps, CarouselState> {
    constructor(props: CarouselProps) {
        super(props);
        this.state = {
            current: 0,
            pause: false,
        };
    }

    static defaultProps = {
        showDots: true,
        showArrow: false,
    };

    componentDidMount(): void {
        const { banners } = this.props;
        if (banners.length <= 1) {
            return;
        }
        setInterval(() => {
            const { current } = this.state;
            if (this.state.pause) {
                return;
            }

            this.setState({
                current: current === banners.length - 1 ? 0 : current + 1,
            });
        }, 3000);
    }

    linkTo = (link: string) => {
        if (this.props.onClick) {
            this.props.onClick(link);
        }
    };

    onChangePosition = (type: "left" | "right") => () => {
        const { current } = this.state;
        const { banners } = this.props;
        const max = banners.length - 1;
        if (type === "left") {
            this.setState({
                current: current > 0 ? current - 1 : max,
            });
        }
        if (type === "right") {
            this.setState({
                current: current < max ? current + 1 : 0,
            });
        }
    };

    renderBody = () => {
        let {
            banners,
            showArrow,
            showDots,
            style = {},
            placeholderBg,
            moduleIndex,
        } = this.props;
        if (!isNotBlankArray(banners)) {
            return null;
        }
        const maxHeight = getMaxHeight(banners);
        const { current } = this.state;
        if (banners.length <= 1) {
            showDots = false;
            showArrow = false;
        }
        return (
            <CarouselWrapper
                onMouseEnter={() => this.setState({ pause: true })}
                onMouseLeave={() => this.setState({ pause: false })}
                style={{
                    ...style,
                    height: `${maxHeight}px`,
                }}
            >
                <ul
                    className={"carouselList"}
                    style={{
                        width: `${banners.length * 100}%`,
                        transform: `translateX(-${
                            (100 / banners.length) * current
                        }%)`,
                    }}
                >
                    {banners.map((item, index) => {
                        const link = item.link;
                        const aProps = transformAParam({
                            isInApp: false,
                            link: item.link,
                            aTarget: LinkTargetType.Blank,
                            onClick: () => this.linkTo(link),
                        });
                        return (
                            <li key={index}>
                                <a data-href={link} {...aProps}>
                                    <NextImage
                                        src={item.img}
                                        isLazyLoad={false}
                                        online={this.props.online}
                                        placeholder={placeholderBg}
                                        fallbackSrc={placeholderBg}
                                        style={{
                                            height: maxHeight,
                                            width: webCarouselWidth,
                                        }}
                                        moduleIndex={moduleIndex}
                                        moduleInnerIndex={index}
                                    />
                                </a>
                            </li>
                        );
                    })}
                </ul>
                {showArrow && [
                    <i
                        key={"left"}
                        onClick={this.onChangePosition("left")}
                        className={"leftBtn"}
                    />,
                    <i
                        key={"right"}
                        onClick={this.onChangePosition("right")}
                        className={"rightBtn"}
                    />,
                ]}
                {showDots && (
                    <ul className={"dots"}>
                        {banners.map((_, index) => (
                            <li
                                onClick={() =>
                                    this.setState({ current: index })
                                }
                                className={index === current ? "active" : ""}
                                key={index}
                            />
                        ))}
                    </ul>
                )}
            </CarouselWrapper>
        );
    };

    render() {
        const {
            positionId,
            className = "",
            style = {},
            banners,
            width = 0,
            minWidth = 0,
        } = this.props;

        if (!isNotBlankArray(banners)) {
            return null;
        }

        const banner = banners[0];
        const { width: gridWidth, height } = formatBannerGridSize(
            banner,
            Math.max(+width, minWidth)
        );

        return (
            <Container
                id={positionId}
                className={className}
                gridWidth={gridWidth}
                gridHeight={height || 300}
                style={{
                    ...style,
                }}
            >
                <React.Fragment>{this.renderBody()}</React.Fragment>
            </Container>
        );
    }
}

export default WebCarousel;
